//  Angular imports
import { Component, OnInit, inject } from '@angular/core';
//  Application imports
import { StorageItem } from 'app/models/storage-item';
import { UserService } from 'app/services/user.service';
//  Third party imports
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationRoute } from 'app/models/application-route';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'zf-logout',
    template: ''
})
export class LogoutComponent implements OnInit {
    private userService = inject(UserService);
    private cookieService = inject(CookieService);
    private route = inject(ActivatedRoute);
    private oidc = inject(OidcSecurityService);
    private router = inject(Router);

    public ngOnInit(): void {
        // We must maintain a unified logout route
        // which our portal, and the IDP, can reach.

        // We must always clear our authentication
        // regardless of the scenario (us, or IDP)
        this.userService.clearAuthenticated();
        this.cookieService.delete(StorageItem.AUTH_TOKEN);

        if (!this.route.snapshot.queryParamMap.has('SAMLResponse')) {
            // We do not have SAMLResponse returned from IDP
            // This means we have clicked logout from our portal
            // so first hit our SP, which will redirect
            // to IDP for logout for others
            this.oidc.logoff().subscribe();
            return;
        }

        // When we have a SAMLResponse in the query parameters (i.e /logout?SAMLResponse=...)
        // we have returned from the IDP, and should redirect our users to the splash screen
        this.router.navigateByUrl(ApplicationRoute.SPLASH);
    }
}
